import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {IconProp} from "@fortawesome/fontawesome-svg-core";

@Component({
    selector: 'app-search-field',
    templateUrl: './search-field.component.html',
    styleUrls: ['./search-field.component.scss'],
    standalone: false
})
export class SearchFieldComponent {

	@Input() searchTerm: string;
	@Input() width = '400px';
	@Input() isLiveSearch = true;
	@Input() disabled = false;
	@Output() doSearch = new EventEmitter<string>();

	fontAwesomeGlyph: IconProp = 'magnifying-glass';
	lastSearchTermEmitted = '';
	
	private readonly searchButtonText = $localize`:XTOL|Tooltip for search button@@search-field.tooltips.searchButton:Search`;
	buttonTooltip = this.searchButtonText;

	constructor(private _cdRef: ChangeDetectorRef) {}

	onChange(searchStr: string) {
	    this.adjustDetails(searchStr);
	    if (this.isLiveSearch) {
	        this.doSearch.emit(searchStr);
	        this.lastSearchTermEmitted = searchStr;
	    }
	}
	
	adjustDetails(searchStr: string) {
	    this.fontAwesomeGlyph = searchStr ? 'xmark' : 'magnifying-glass';
	    this.buttonTooltip = searchStr ? $localize`:XTOL|Tooltip for clear search button@@search-field.tooltips.clearButton:Clear Search` :
	        this.searchButtonText;
	}

	onButtonClick(searchStr: string) {
	    this.adjustDetails(searchStr);
	    this.searchTerm = searchStr;
	    this.doSearch.emit(searchStr);
	    this.lastSearchTermEmitted = searchStr;
	    this._cdRef.detectChanges();
	}
}
